import { render, staticRenderFns } from "./taos.vue?vue&type=template&id=5a3a88f2&scoped=true&"
import script from "./taos.vue?vue&type=script&lang=js&"
export * from "./taos.vue?vue&type=script&lang=js&"
import style0 from "./taos.vue?vue&type=style&index=0&id=5a3a88f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a88f2",
  null
  
)

export default component.exports